'use client';

import React from 'react';

import { withEventScope } from '@repo/event-processor';

import ErrorPage, { ErrorStatus, ErrorPageProps } from '../ErrorPage/ErrorPage';

type NotFoundPageProps = Omit<ErrorPageProps, 'status'>;

const NotFoundPage: React.FC<NotFoundPageProps> = (props) => {
  return <ErrorPage {...props} status={ErrorStatus.NotFound} />;
};

export default withEventScope(NotFoundPage, { page: 'notFound' });
